import React from "react";
import RadioButton from "components/shared/form/fields/RadioButton";

function ChatSettings() {
  return (
    <div className="form-horizontal">
      <RadioButton
        key="chat"
        name="chat"
        label={I18n.t(`js.groups.form.chat`)}
        options={[
          { value: "enabled", label: I18n.t("js.groups.form.chat_enabled") },
          { value: "disabled", label: I18n.t("js.groups.form.chat_disabled") },
        ]}
      />
    </div>
  );
}

export default ChatSettings;
